import { Artist } from './artist';
import { API_BASE, asArray } from '../../../config/api';

export async function getArtistList(): Promise<Artist[]> {
    try {
        const response = await fetch(`${API_BASE}/api/artist`);
        const result = await response.json();

        if (!response.ok) {
            throw new Error(`Error fetching artist list: ${result.message || response.statusText}`);
        }

        return asArray<any>(result).map((a: any) => Artist.fromJson(a));
    } catch (error) {
        console.error(error);
        return [];
    }
}

export async function getRecentArtists(limit: number): Promise<Artist[]> {
    try {
        const response = await fetch(`${API_BASE}/api/artist?sort=recent&limit=${limit}`);
        const result = await response.json();

        if (!response.ok) {
            throw new Error(`Error fetching recent artists: ${result.message || response.statusText}`);
        }

        return asArray<any>(result).map((a: any) => Artist.fromJson(a));
    } catch (error) {
        console.error(error);
        return [];
    }
}

export async function getArtistByID(id: number): Promise<Artist | null> {
    try {
        const response = await fetch(`${API_BASE}/api/artist?id=${id}`);
        const result = await response.json();

        if (!response.ok) {
            throw new Error(`Error fetching artist: ${result.message || response.statusText}`);
        }

        return Artist.fromJson(result);
    } catch (error) {
        console.error(error);
        return null;
    }
}
